import { request } from '@umijs/max';

// 获取审批列表
export async function getWorkflowUserPage(params: API.PageParams) {
  return request('/api/admin/workflowUser/page', {
    method: 'POST',
    data: {
      ...params,
      with: [
        'shop',
        'operator',
        'streetAdminUser',
        'districtAdminUser',
        'rentFiles',
        'sfzFiles',
        'hukouFiles',
        'dibaoFiles',
        'nengliFiles',
      ],
    },
  });
}

// 获取审批详情
export async function getWorkflowUserInfo(params: { id: number }) {
  return request('/api/admin/workflowUser/info', {
    method: 'POST',
    data: {
      ...params,
      with: [
        'shop',
        'operator',
        'streetAdminUser',
        'districtAdminUser',
        'rentFiles',
        'sfzFiles',
        'hukouFiles',
        'dibaoFiles',
        'nengliFiles',
      ],
    },
  });
}

// 街道审批
export async function workflowUserStreetVerify(params: {
  id: number;
  street_verify_status: number;
  verify_remark: string;
}) {
  return request('/api/admin/workflowUser/streetVerify', {
    method: 'POST',
    data: params,
  });
}

// 区县预查
export async function workflowUserDistrictVerifyPre(params: { id: number }) {
  return request('/api/admin/workflowUser/districtVerifyPre', {
    method: 'POST',
    data: params,
  });
}

// 区县审批
export async function workflowUserDistrictVerify(params: {
  id: number;
  district_verify_status: number;
  verify_remark: string;
  merge_type: number;
}) {
  return request('/api/admin/workflowUser/districtVerify', {
    method: 'POST',
    data: params,
  });
}
